import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";
import {NavigationService} from "../navigation/navigation.service";
import {ListingService} from "./listing.service";
import {ListingConfiguration} from "../../models/listing-configuration";


/**
 * Class > ListingConfigurationResolver
 */
@Injectable()
export class ListingConfigurationResolver
{

	/**
	 * Function > constructor
	 * @param {ListingService} OBJ_listing_service
	 * @param {NavigationService} OBJ_navigation_service
	 */
	constructor
    (
        private OBJ_listing_service: ListingService,
        private OBJ_navigation_service: NavigationService,
    ) {} // end function constructor


	/**
     * Function > resolve
	 * @param {ActivatedRouteSnapshot} OBJ_route
	 * @param OBJ_state
	 * @returns {Observable<ListingConfiguration>}
	 */
	resolve(OBJ_route: ActivatedRouteSnapshot, OBJ_state: RouterStateSnapshot): Observable<Object>
	{
        let STR_route_submenu = OBJ_route.paramMap.get("route_submenu");

        let STR_route_menu = OBJ_route.parent.paramMap.get("route_menu");

		let STR_listing_id = OBJ_route.paramMap.get("listing_id");

		let STR_config_endpoint;

		// Listing
		STR_config_endpoint = this.OBJ_navigation_service.getListingConfigEndpointByRoute(STR_route_menu, STR_route_submenu, STR_listing_id);

		return this.OBJ_listing_service.getListingConfig(STR_config_endpoint);

	} // end function resolve


} // end class ListingConfigurationResolver
